// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'

const PageNotFound = ({ location }) => (
  <div className={'padding-1'}>
    <div>
      <h1>{'404'}</h1>
      <p>
        <code
          className={'bg-grey-blue'}>
          {location.pathname}
        </code>
        <span>{' was not found'}</span>
      </p>
    </div>
  </div>
)

PageNotFound.propTypes = {
  location: object.isRequired,
}

export default PageNotFound
